import { useState, useEffect, useCallback } from 'react';

const useFetchFavouriteJobs = () => {
  const [favouriteJobs, setFavouriteJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  
  const fetchFavouriteJobs = useCallback(async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_STAGING_URL}/api/employees/favorite-jobs`, {
        method: 'GET',
        credentials: 'include',
      });
      
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response.json();
      
      const jobsArray = data.data || [];
      
      // Ensure we always have an array
      setFavouriteJobs(Array.isArray(jobsArray) ? jobsArray : []);
    } catch (error) {
      console.error('Error fetching favorite jobs:', error);
      setError(error.message);
      setFavouriteJobs([]); // Ensure favouriteJobs remains an empty array on error
    } finally {
      setLoading(false);
    }
  }, []); // Empty dependency array since this function doesn't depend on any props or state

  const triggerFetchFavouriteJobs = useCallback(() => {
    setLoading(true);
    setError(null);
    fetchFavouriteJobs();
  }, [fetchFavouriteJobs]);
 
  useEffect(() => {
    // Don't fetch favorite jobs on the application page to prevent infinite loops
    if (!window.location.pathname.includes('/aplicar')) {
      fetchFavouriteJobs();
    } else {
      // Set loading to false immediately on application page
      setLoading(false);
    }
  }, [fetchFavouriteJobs]); // Now this is safe because fetchFavouriteJobs won't change

  return { favouriteJobs, loading, error, fetchFavouriteJobs, triggerFetchFavouriteJobs };
};

export default useFetchFavouriteJobs;
